export default {
    bind(el, binding) {
      el.clickOutsideEvent = function(event) {
        // Check if the clicked element is outside the bound element
        if (!(el === event.target || el.contains(event.target))) {
          // Call the method provided in the directive binding, passing the event
          binding.value(event);
        }
      };
      document.body.addEventListener('click', el.clickOutsideEvent);
    },
    unbind(el) {
      document.body.removeEventListener('click', el.clickOutsideEvent);
    },
  };